import { ReactElement, useEffect, useState } from 'react';
import styles from '@/styles/components/shade-loding.module.less';
import { Col, Row } from 'antd';
import { SwapOutlined } from '@ant-design/icons';
import Image from '@/components/LocalImage';
const SwapLoad = (props: SwapLoadData): ReactElement => {
    console.log('=======>swapProps:', props);
    const [tokenIcon, setTokenIcon] = useState<string>('token');
    const [ctokenIcon, setCtokenIcon] = useState<string>('usdt');
    useEffect(() => {
        setTokenIcon(props.tokenIcon);
        setCtokenIcon(props.cTokenIcon);
    }, [props]);
    return (
        <div className={styles['swap']}>
            <Row justify="center">
                <Col className={styles['col']} span={10}>
                    <Row justify="center">
                        <Col span={4}>{tokenIcon ? <Image className={styles['icon']} name={tokenIcon} height={16} type="svg" dir="/images/token"></Image> : ''}</Col>
                        <Col span={10}>{props.token}</Col>
                        <Col span={6}>{props.tokenSymbol}</Col>
                    </Row>
                </Col>
                <Col className={styles['change-icon']} span={2}>
                    <SwapOutlined />
                </Col>
                <Col className={styles['col']} span={10}>
                    <Row justify="center">
                        <Col span={4}>{ctokenIcon ? <Image className={styles['icon']} name={ctokenIcon} height={16} type="svg" dir="/images/token"></Image> : ''}</Col>
                        <Col span={10}>{props.cToken}</Col>
                        <Col span={6}>{props.cTokenSymbol}</Col>
                    </Row>
                </Col>
            </Row>
        </div>
    );
};

export default SwapLoad;
